import BranchService from '@/services/branch.service'
import Utils from '@/utils'
import _ from 'lodash'

const state = {
    page: {
        results: [],
        count: 0,
        next: null,
        previous: null
    },
    reading: false,
    creatingRelationship: false,
    nameIds: [
        {
            id: 'A',
            name: 'Todas',
        }
    ],
    channels: [
        {
            id: 'A',
            name: 'Todos'
        }
    ],

    loadingDcs: false,
    dcs: [],

    loadingProducts: false,
    products: [],

    dcNames: [],

    selectedItems: [],

    relationships: [],

    savingRelationships: false,

    typesSale: [
        { id: 'S', description: 'Saída Loja' },
        { id: 'D', description: 'Saída CD' }
    ],

    loadingBranches: false,
    branches: [],

    branchLoading: false,
    branch: {}
}

const getters = {}

const actions = {
    selectItems: ({ commit }, items) => {
        commit('selectItemsSuccess', items)
        return null
    },

    create: async ({ commit }, args) => {
        try {
            await BranchService.create(args)
            commit('createBranchSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    createRelationship: async ({ commit }, args) => {
        if (!args || !args.branch_id || !args.dc_id || !args.node_id) return

        try {
            let result = BranchService.createRelationship(
                args.branch_id,
                args.dc_id,
                args.node_id
            )
            commit('creatingBranchRelationshipSuccess')
            result = await result
            commit('createBranchRelationshipSuccess')
            return result.data
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    read: async ({ commit }, args) => {
        if (!args) args = {}
        if (!args.page) args.page = 1
        if (!args.limit) args.limit = 20
        if (state.page.index == args.page) return true
        try {
            let page = BranchService.read(args)
            commit('readingSuccess')
            page = await page
            commit('readBranchesSuccess', page.data, args.page)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    readById: async ({ commit }, id) => {
        if (!id) return true
        try {
            commit('readingBranch')
            const branch = await BranchService.readById(id)
            commit('readBranchSuccess', branch.data)
        } catch (e) {
            if (e && e.response) throw e.response.status
            else throw 500
        }
    },

    more: async ({ commit }, url) => {
        if (!url) return

        try {
            let page = BranchService.readUrl(url)
            commit('readingSuccess')
            page = await page
            commit(
                'readMoreSuccess',
                page.data,
                new URLSearchParams(url).get('page')
            )
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    readChannels: async ({ commit }) => {
        try {
            let channels = await BranchService.readChannels()
            commit('readChannelsSuccess', channels)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    readDcs: async ({ commit }, args) => {
        if (state.loadingDcs) return
        try {
            state.loadingDcs = true
            let dcs = await BranchService.readDcs(args)
            commit('readDcsSuccess', dcs.data)
            state.loadingDcs = false
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    readProducts: async ({ commit }, args) => {
        if (state.loadingProducts) return
        try {
            state.loadingProducts = true
            const products = await BranchService.readProducts(args)
            commit('readProductsSuccess', products.data)
            state.loadingProducts = false
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    readBranches: async ({ commit }, args) => {
        if (state.loadingBranches) return
        try {
            state.loadingBranches = true
            const branches = await BranchService.readBranches(args)
            commit('readListBranchesSuccess', branches.data)
            state.loadingBranches = false
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },
    readNameIds: async ({ commit }, args) => {
        try {
            let nameIds = await BranchService.readNameIds(args)
            commit('readNameIdsSuccess', nameIds.data)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    update: async ({ commit }, args) => {
        try {
            await BranchService.update(args.id, args)
            commit('updateBranchSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    delete: async ({ commit }, { id }) => {
        try {
            await BranchService.delete(id)
            commit('deleteBranchSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    deleteRelationship: async ({ commit }, id) => {
        if (!id) return
        try {
            await BranchService.deleteRelationship(id)
            commit('deleteRelationshipBranchSuccess')
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    readDcNamesById: async ({ commit }, id) => {
        try {
            let data = await BranchService.readDcNamesById(id)
            commit('readDcNamesByIdSuccess', data.data)
            return null
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    clearRelationships: ({ commit }, new_array = []) => {
        commit('readRelationshipsSuccess', new_array)
    },

    readRelationships: async ({ commit }, args) => {
        try {
            let relationships = await BranchService.readRelationships(args)
            commit('readRelationshipsSuccess', relationships.data.results)
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    },

    saveRelationships: async ({ commit }, relationships) => {
        try {
            let response = BranchService.saveRelationships(relationships)
            commit('savingRelationshipsSuccess', true)
            response = await response
            commit('savingRelationshipsSuccess', false)
        } catch (e) {
            if (e && e.response) return e.response.status
            else return 500
        }
    }
}

const mutations = {
    selectItemsSuccess(state, items) {
        state.selectedItems = items
    },
    createBranchSuccess(state) {
        // success
    },

    creatingBranchRelationshipSuccess(state) {
        state.creatingRelationship = true
    },
    createBranchRelationshipSuccess(state) {
        state.creatingRelationship = false
    },
    readingSuccess(state) {
        state.reading = true
    },
    readingBranch() {
        state.branchLoading = true
    },
    readBranchSuccess(state, branch) {
        state.branchLoading = false
        state.branch = branch
    },
    readBranchesSuccess(state, page, page_index) {
        state.reading = false
        Utils.datetimeConverter(page.results)
        state.page = page
        state.page.index = page_index
    },
    readMoreSuccess(state, page, page_index) {
        state.reading = false
        Utils.datetimeConverter(page.results)
        state.page.next = page.next
        state.page.previous = page.previous

        let current_results = _.cloneDeep(state.page.results)
        state.page.results = current_results.concat(page.results)

        state.page.index = page_index
    },
    readChannelsSuccess(state, channels) {
        state.channels = [
            {
                id: 'A',
                name: 'Todos'
            },
            ...channels
        ]
    },
    readDcsSuccess(state, dcs) {
        state.dcs = dcs
    },
    readProductsSuccess(state, products) {
        state.products = products
    },
    readListBranchesSuccess(state, branches) {
        branches.shift()
        state.branches = branches
    },
    readNameIdsSuccess(state, nameIds) {
        state.nameIds = [
            {
                id: 'A',
                name: 'Todas'
            },
            ...nameIds
        ]
    },
    updateBranchSuccess(state) {
        // success
    },
    deleteBranchSuccess(state) {
        // success
    },
    deleteRelationshipBranchSuccess(state) { },
    readDcNamesByIdSuccess(state, dcNames) {
        state.dcNames = dcNames
    },
    readRelationshipsSuccess(state, relationships) {
        state.relationships = relationships
    },
    savingRelationshipsSuccess(state, payload) {
        state.savingRelationships = payload
    },
    mapNames(state) {
        state.page.results = state.page.results.map(branch => {
            branch.name = branch.external_id + ' - ' + branch.name
            return branch
        })
    }
}

const branches = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}

export default branches
export { branches }
